// extracted by mini-css-extract-plugin
export default {"years-block":"Im7J2","years-block__list":"cBQh5","years-block__year":"mNZqx"};